jQuery(document).ready(function () {
  tm_slider();
  trusted_slider();
  // faqs_accordion();
  tab_click_fun();

  testimonial();
  outof_box_slider();
  smooth_scroll();
  // jQuery(".booth_section .view_location").click(function () {
  //   jQuery.fancybox({
  //     href: "#view_location_popup",
  //     wrapCSS: "location_section",
  //   });
  // });
});

function testimonial() {
  var TestimonialSlider = jQuery(".client_slider");
  TestimonialSlider.owlCarousel({
    autoplay: true,
    slideSpeed: 500,
    smartSpeed: 500,
    loop: true,
    nav: false,
    dots: true,
    items: 1,
    autoplayHoverPause: true,
    autowidth: false,
    animateOut: "fadeOut",
  });
}
function outof_box_slider() {
  var TestimonialSlider = jQuery(".box_slider");
  TestimonialSlider.owlCarousel({
    stagePadding: 218,
    loop: true,
    items: 1,
    dots: true,
    lazyLoad: true,
    autoplay: true,
    autoplaySpeed: 2000,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    mouseDrag: true,
    slideSpeed: 1000,
    smartSpeed: 1000,
    responsive: {
      0: {
        stagePadding: 0,
      },
      1100: {
        stagePadding: 42,
      },
      1200: {
        stagePadding: 50,
      },
      1440: {
        stagePadding: 25,
      },
      1500: {
        stagePadding: 68,
      },
      1600: {
        stagePadding: 218,
      },
    },
  });
}
function smooth_scroll() {
  var h_height = jQuery(".biztech-header").outerHeight();
  jQuery('a[href*="#"].btn').on("click", function (e) {
    e.preventDefault();
    jQuery("html, body").animate(
      {
        scrollTop: jQuery(jQuery(this).attr("href")).offset().top - h_height,
      },
      600
    );
  });
}

// tm-slider js start
function tm_slider() {
  jQuery(".tm-slider").owlCarousel({
    items: 1,
    loop: true,
    margin: 0,
    nav: true,
    dots: false,
    autoplay: false,
    smartSpeed: 2200,
    autoplayTimeout: 4500,
    autoplayHoverPause: true,
    paginationSpeed: 1500,
    animateOut: "fadeOut",
    responsive: {
      768: {
        autoplay: true,
      },
    },
  });
}

// trusted_slider js
function trusted_slider() {
  jQuery(".trusted_slider").owlCarousel({
    loop: true,
    autoplay: true,
    margin: 0,
    nav: false,
    autoplayTimeout: 3000,
    slideSpeed: 2000,
    dots: false,
    responsive: {
      0: {
        items: 2,
      },

      700: {
        items: 3,
      },

      1100: {
        items: 4,
      },

      1366: {
        items: 5,
      },
    },
  });
}

// FAQs accordion js start here
// function faqs_accordion() {
//   jQuery("#faq .accordian > div,#faq .accordian .accordion-item")
//     .slice(0, 8)
//     .show();
//   jQuery("#loadmore").on("click", function (e) {
//     e.preventDefault();
//     jQuery(
//       "#faq .accordian > div:hidden,#faq .accordian .accordion-item:hidden"
//     )
//       .slice(0, 8)
//       .slideDown();
//     if (
//       jQuery(
//         "#faq .accordian > div:hidden,#faq .accordian .accordion-item:hidden"
//       ).length == 0
//     ) {
//       jQuery("#loadmore").fadeOut("slow");
//     }
//   });

//   jQuery(".faq_section .accordion .accordion-item").slice(0, 8).show();
//   jQuery("#loadmore").on("click", function (e) {
//     e.preventDefault();
//     jQuery(".faq_section .accordion .accordion-item:hidden")
//       .slice(0, 8)
//       .slideDown();
//     if (jQuery(".faq_section .accordion .accordion-item:hidden").length == 0) {
//       jQuery("#loadmore").fadeOut("slow");
//     }
//   });
//   //   jQuery.fn.accordion = function () {
//   //     const trigger = jQuery(this).find(".accordion-one");
//   //     const collapse = jQuery(this).find(".collapse-one");

//   //     jQuery(trigger).first().addClass("accordion-open");
//   //     jQuery(collapse).first().show();

//   //     jQuery(trigger).each(function () {
//   //       jQuery(this).on("click", function () {
//   //         jQuery(this).siblings(".collapse-one").slideToggle();
//   //         jQuery(this).toggleClass("accordion-open");
//   //         jQuery(this).parent().toggleClass("show_item");
//   //         jQuery(this)
//   //           .parent()
//   //           .siblings(".accordion-item")
//   //           .find(".accordion-one")
//   //           .removeClass("accordion-open");
//   //         jQuery(this)
//   //           .parent()
//   //           .siblings(".accordion-item")
//   //           .find(".collapse-one")
//   //           .slideUp();
//   //         jQuery(this)
//   //           .parent()
//   //           .siblings(".accordion-item")
//   //           .removeClass("show_item");
//   //       });
//   //     });
//   //   };
//   //   jQuery(".accordion").accordion();
// }


function tab_click_fun() {
  $('#login-img').show();
  $('#payment-img').hide();
  $('#order-img').hide();
  $('#currency-img').hide();
  $('#category-img').hide();
  $('#dashboard-img').hide();
  $('#rating-img').hide();
  $('#favourites-img').hide();
  $('h4#login').click(function() {
      $('#login-img').show();
      $('#payment-img').hide();
      $('#order-img').hide();
      $('#currency-img').hide();
      $('#category-img').hide();
      $('#dashboard-img').hide();
      $('#rating-img').hide();
      $('#favourites-img').hide();
      $('h4.active').removeClass('active');
      $(this).addClass('active');
  });
  $('h4#payment').click(function() {
      $('#payment-img').show();
      $('#login-img').hide();
      $('#order-img').hide();
      $('#currency-img').hide();
      $('#category-img').hide();
      $('#dashboard-img').hide();
      $('#rating-img').hide();
      $('#favourites-img').hide();
      $('h4.active').removeClass('active');
      $(this).addClass('active');
  });
  $('h4#order').click(function() {
      $('#order-img').show();
      $('#payment-img').hide();
      $('#login-img').hide();
      $('#currency-img').hide();
      $('#category-img').hide();
      $('#dashboard-img').hide();
      $('#rating-img').hide();
      $('#favourites-img').hide();
      $('h4.active').removeClass('active');
      $(this).addClass('active');
  });
  $('h4#currency').click(function() {
      $('#currency-img').show();
      $('#order-img').hide();
      $('#payment-img').hide();
      $('#login-img').hide();
      $('#category-img').hide();
      $('#dashboard-img').hide();
      $('#rating-img').hide();
      $('#favourites-img').hide();
      $('h4.active').removeClass('active');
      $(this).addClass('active');
  });
  $('h4#dashboard').click(function() {
      $('#login-img').hide();
      $('#payment-img').hide();
      $('#order-img').hide();
      $('#currency-img').hide();
      $('#category-img').hide();
      $('#dashboard-img').show();
      $('#rating-img').hide();
      $('#favourites-img').hide();
      $('h4.active').removeClass('active');
      $(this).addClass('active');
  });
  $('h4#rating').click(function() {
      $('#login-img').hide();
      $('#payment-img').hide();
      $('#order-img').hide();
      $('#currency-img').hide();
      $('#category-img').hide();
      $('#dashboard-img').hide();
      $('#rating-img').show();
      $('#favourites-img').hide();
      $('h4.active').removeClass('active');
      $(this).addClass('active');
  });
  $('h4#add-favourite').click(function() {
      $('#login-img').hide();
      $('#payment-img').hide();
      $('#order-img').hide();
      $('#currency-img').hide();
      $('#category-img').hide();
      $('#dashboard-img').hide();
      $('#rating-img').hide();
      $('#favourites-img').show();
      $('h4.active').removeClass('active');
      $(this).addClass('active');
  });
  $('h4#product-category').click(function() {
      $('#login-img').hide();
      $('#payment-img').hide();
      $('#order-img').hide();
      $('#currency-img').hide();
      $('#category-img').show();
      $('#dashboard-img').hide();
      $('#rating-img').hide();
      $('#favourites-img').hide();
      $('h4.active').removeClass('active');
      $(this).addClass('active');
  });
}



// WEBPACK FOOTER //
// ./scripts/misc/script.js